module.exports = __webpack_public_path__ + "img/chetko.a6df8a12.jpg";